import MagicGrid from 'magic-grid';

(() => {
  const postGrid = document.querySelectorAll('.m07__insights');

  postGrid.forEach(grid => {
    const magicGrid = new MagicGrid({
      container: grid,
      gutter: 40,
      static: true,
      animate: false
    });

    magicGrid.listen();
  });
})();
